import React from "react";
import "./CheckoutItem.scss";
import { ChevronLeft, ChevronRight, Delete } from "@material-ui/icons";
import {
  addItemToCart,
  decreaseQuantity,
  removeItem,
} from "../../Redux/Cart/cart.utils";
import { useDispatch, useSelector } from "react-redux";
import { setCart } from "../../Redux/Cart/Cart.actions";

const CheckoutItem = ({ data }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.cart);

  const addItem = () => {
    const newCart = addItemToCart(null, cart, data, false);
    dispatch(setCart(newCart));
  };

  const decrease = () => {
    const newCart = decreaseQuantity(cart, data);
    dispatch(setCart(newCart));
  };

  const delItem = () => {
    const confirm = window.confirm(
      "Are you sure you want to delete this item from cart?"
    );

    if (confirm) {
      const newCart = removeItem(cart, data);
      dispatch(setCart(newCart));
    }
  };

  return (
    <div className="CheckoutItem">
      <img src={data.product.images[0]} alt="asas" className="p-img" />
      <p className="name">{data.product.name}</p>
      <div className="quantity">
        <ChevronLeft style={{ cursor: "pointer" }} onClick={decrease} />
        <p>{data.quantity}</p>
        <ChevronRight style={{ cursor: "pointer" }} onClick={addItem} />
      </div>
      <p className="price">&pound;{data.total * data.quantity}</p>
      <Delete color="error" style={{ cursor: "pointer" }} onClick={delItem} />
    </div>
  );
};

export default CheckoutItem;
